'use client';

import NotFoundPage from "@/ui/sections/common/not-found";

export default function NotFound() {
  return (
    <NotFoundPage></NotFoundPage>
  );
}
